var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStoreAndApi = function SvgStoreAndApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73 1.945c0-.833.676-1.508 1.508-1.508h11.847a1.507 1.507 0 0 1 0 3.015H4.238A1.507 1.507 0 0 1 2.73 1.945ZM2.73 18.06c0-.83.674-1.503 1.504-1.503H16.09a1.503 1.503 0 1 1 0 3.006H4.233c-.83 0-1.502-.673-1.502-1.503Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.39 8.106c0-.855.693-1.548 1.548-1.548h16.41c.855 0 1.548.693 1.548 1.548v3.784c0 .855-.694 1.548-1.548 1.548H1.938A1.548 1.548 0 0 1 .39 11.89V8.106Zm1.728.946c0-.428.346-.774.774-.774h1.882c.427 0 .774.346.774.774v1.892a.774.774 0 0 1-.774.774H2.892a.774.774 0 0 1-.774-.774V9.052Zm6.226-.172a1.118 1.118 0 1 0 0 2.236h7.647a1.118 1.118 0 0 0 0-2.236H8.344Z",
    fill: "currentColor"
  })));
};

export default SvgStoreAndApi;